import { DrawLinesAnim, MoveAngles, PointAnim, RotateAngle } from "./helpers/drawHelpers";


export function runAnimation(context, isActive: boolean, cb: () => void) {

  if (isActive) {
    onSupplementaryMode(context, cb);
  } else {
    offSupplementaryMode(context, cb);
  }
}

export async function onSupplementaryMode(context, cb: () => void) {
  const {
    LineManager,
    PointManager,
    AngleManager,
  } = context;

  const redPoints = PointManager.getRedPoints();
  const pointCoords = redPoints.map(r => ({ x: r.x, y: r.y }))
  const angles = AngleManager.getAngles();
  const lC = LineManager.getGuideLinesCoords(pointCoords);
  const rots = [
    -Math.PI / 180 * angles[3].degree,
    Math.PI / 180 * angles[0].degree
  ]

  await PointAnim([redPoints[0], redPoints[3]], false);
  await DrawLinesAnim([LineManager.guideLine1, LineManager.guideLine2], lC, false)
  await MoveAngles([angles[0], angles[3]], [pointCoords[2], pointCoords[1]]);
  await RotateAngle([angles[0], angles[3]], rots);
  cb();
}

export async function offSupplementaryMode(context, cb: () => void) {
  const {
    LineManager,
    PointManager,
    AngleManager,
  } = context;

  const redPoints = PointManager.getRedPoints();
  const pointCoords = redPoints.map(r => ({ x: r.x, y: r.y }))
  const angles = AngleManager.getAngles();
  const lC = LineManager.getGuideLinesCoords(pointCoords);
  const _rots = [
    -Math.PI / 180 * angles[3].degree,
    Math.PI / 180 * angles[0].degree,
  ]
  const rots = angles[0].rotation == 0 && angles[3].rotation == 0 ? _rots : [0, 0];

  await MoveAngles([angles[0], angles[3]], [pointCoords[0], pointCoords[3]]);
  await RotateAngle([angles[0], angles[3]], rots);
  await DrawLinesAnim([LineManager.guideLine1, LineManager.guideLine2], lC, true)
  await PointAnim([redPoints[0], redPoints[3]], true);

  cb();
}